var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"players-names"},[_c('div',{staticClass:"player"},[_c('input',{staticClass:"input-shootlist",class:_vm.value!=null&&_vm.value!=''?'active':'',attrs:{"placeholder":_vm.$ml.get('שם משתתף')+' '+(_vm.counter+1)},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }